import axiosInstance from '../config/axiosConfig';

/**
 * Returns the company logo_url from GET /company/profile.
 * The URL is used directly as an img src; Avatar falls back to initials if S3 is inaccessible.
 */
export async function fetchCompanyLogoUrl() {
  try {
    const res = await axiosInstance.get('/company/profile');
    return res.data?.entity?.logo_url || null;
  } catch {
    return null;
  }
}
